import { createSlice } from '@reduxjs/toolkit';

import { getSearchParams } from 'utils/urls';
import { XHR_STATUS } from 'constants/xhr-status';
import { getPersonalView } from '../../_api/tableViews';

const defaultFilters = [];

const searchParams = getSearchParams();
const initialState = {
  links: {
    filters: defaultFilters,
    searchValue: '',
    sortData: {},
    filterLink: 'and',
    page: searchParams.page ? Number(searchParams.page) : 0,
    perPage: searchParams.count ? Number(searchParams.count) : 25,
    orderedFields: [],
  },
  personalFiltersStatus: XHR_STATUS.idle,
};

const filters = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setLinkFilters: (state, action) => {
      state.links.filters = action.payload;
    },
    setLinkSearchValue: (state, action) => {
      state.links.searchValue = action.payload;
    },
    setLinkSortData: (state, action) => {
      state.links.sortData = action.payload;
    },
    setLinkFilterLink: (state, action) => {
      state.links.filterLink = action.payload;
    },
    setLinkPage: (state, action) => {
      state.links.page = action.payload;
    },
    setLinkPerPage: (state, action) => {
      state.links.perPage = action.payload;
    },
    resetFilters: (state) => {
      state.links = initialState.links;
      state.personalFiltersStatus = XHR_STATUS.idle;
    },
    setOrderedFields: (state, action) => {
      state.links.orderedFields = action.payload;
    },
  },
  extraReducers: {
    [getPersonalView.pending]: (state) => {
      state.personalFiltersStatus = XHR_STATUS.pending;
    },
    [getPersonalView.fulfilled]: (state, { payload }) => {
      const  { data: { table_data: tableData } } = payload;

      if (tableData.filter.filterModel.items) {
        state.links.filters = tableData.filter.filterModel.items
          .map(({ value, type, columnField, operatorValue }) => ({
            column: columnField,
            operator: operatorValue,
            columnField,
            operatorValue,
            value,
            type,
          }));

        state.links.filterLink = tableData.filter.filterModel.linkOperator;
      }

      if (tableData.columns.orderedFields) {
        state.links.orderedFields = tableData.columns.orderedFields;
      }

      state.personalFiltersStatus = XHR_STATUS.fulfilled;
    },
    [getPersonalView.rejected]: (state) => {
      state.personalFiltersStatus = XHR_STATUS.rejected;
    },
  },
});

export default filters.reducer;

export const {
  setLinkFilters,
  setLinkSearchValue,
  setLinkSortData,
  setLinkPage,
  setLinkPerPage,
  setLinkFilterLink,
  resetFilters,
  setOrderedFields,
} = filters.actions;
